import React, {useState} from 'react';
import IndicatorLocation from "../map/indicator/IndicatorLocation";

const HeaderNav = ({
                       searchAction = true,
                       searchElement,
                       indicator = false,
                       indicatorColor = null,
                       title,
                       backToDo
                   }) => {

    const [inSearch, setInSearch] = useState(false)

    return (
        <div className={`nav-header  ${inSearch ? 'nav-header-search' : ''}`}
             onBlur={() => !searchElement.searchText && setInSearch(false)}
        >
            <div className={'back-action'} onClick={backToDo}>
                <i className="fas fa-chevron-left"/>
            </div>
            {

                <div className={'nav-head-title'}>
                    {title || ''}
                    {
                        inSearch &&
                        <input autoFocus
                               placeholder="Rechercher ..." id="search-dockyards" type="text"
                               className="search-input" value={searchElement.searchText}
                               onChange={(e) => searchElement.setSearchText(e.target.value)}/>
                    }
                </div>

            }
            {
                searchAction &&
                <div className={`search-action`}>
                    <div onClick={() => setInSearch(!inSearch)}>
                        <i className="fas fa-search"/>
                    </div>
                </div>
            }
            {
                indicator && indicatorColor && <IndicatorLocation indicatorColor={indicatorColor}/>
            }
        </div>
    )
};

export default HeaderNav;